import React from "react";
import { FaStar } from "react-icons/fa";
import {
  HiOutlineLocationMarker,
  HiOutlineUserGroup,
  HiOutlineClock,
  HiOutlineTag,
  HiOutlineStar,
} from "react-icons/hi";
import { FiTag } from "react-icons/fi";

const ExperienceInfo = ({
  title = "-",
  rating = "-",
  reviewsCount = 0,
  location = {},
  price = "-",
  category = "-",
  duration = "-",
  priceType = "Person",
  description = `-`,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-6 py-6 md:px-8 md:py-8">
      {/* Title + rating */}
      <div>
        <h1 className="text-[24px] md:text-[26px] font-semibold text-gray-900">
          {title}
        </h1>

        <div className="mt-3 flex items-center gap-3">
          {/* 5 stars */}
          {reviewsCount <= 0 ? (
            <div>New Experience</div>
          ) : (
            <>
              <div className="flex items-center gap-1 text-[#FFC700]">
                {Array.from({ length: Math.ceil(rating) }).map((_, idx) => (
                  <FaStar key={idx} size={18} />
                ))}
              </div>

              {/* rating text */}
              <p className="text-sm md:text-base text-gray-800">
                <span className="font-semibold">({Math.ceil(rating)})</span>
                <span className="mx-1">,</span>
                <span className="uppercase tracking-wide">
                  {reviewsCount} REVIEWS
                </span>
              </p>
            </>
          )}
        </div>
      </div>

      {/* Info rows */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-y-6">
        {/* Left column: Location + Price */}
        <div className="space-y-6">
          <div className="flex items-start gap-3">
            <HiOutlineLocationMarker
              size={22}
              className="text-gray-900 mt-0.5"
            />
            <div>
              <p className="text-sm font-medium text-gray-700">Location</p>
              <p className="text-sm md:text-base text-gray-900">
                {`${location?.country}, ${location?.city}`}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <FiTag size={20} className="text-gray-900 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-gray-700">Price</p>
              <p className="text-sm md:text-base text-gray-900">${price}</p>
            </div>
          </div>
        </div>

        {/* Right column: People + Duration */}
        <div className="space-y-6 md:text-right">
          <div className="flex items-start md:justify-end">
            <HiOutlineTag size={22} className="text-gray-900 mt-0.5" />
            <div className="text-left md:text-right">
              <p className="text-sm font-medium text-gray-700">Category</p>
              <p className="text-sm md:text-base text-gray-900 ml-3">
                {category}
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 md:justify-end">
            <HiOutlineStar size={22} className="text-gray-900 mt-0.5" />
            <div className="text-left md:text-right">
              <p className="text-sm font-medium text-gray-700">Rating</p>
              <p className="text-sm md:text-base text-gray-900">
                {" "}
                {"★".repeat(Math.ceil(duration)) || "-"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Divider + About section */}
      <div className="mt-8 border-t border-gray-200 pt-6">
        <h2 className="text-lg md:text-xl font-semibold text-gray-900">
          About this Experience
        </h2>
        <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-gray-700">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ExperienceInfo;
